import AddSchemVillage from "../components/configuration/SchemeVillage/AddSchemVillage";

const AddSchemeVillagePage = () => {
  return (
    <AddSchemVillage />
  );
};

export default AddSchemeVillagePage;
